import { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn } from "@fortawesome/pro-regular-svg-icons";
import { find } from "lodash";

type ActorImageArgs = {
  url: string;
  displayName: string;
  images:
    | { [key: string]: string }
    | { url: string; width: number; height: number }[];
};
export default function ActorImage({
  url,
  displayName,
  images,
}: ActorImageArgs) {
  function ImageWrapper({ children }: { children: ReactNode }) {
    if (url) {
      return (
        <a className="member-link" href={url} title={displayName} aria-hidden>
          {children}
        </a>
      );
    } else {
      return <span className="member-link">{children}</span>;
    }
  }

  const imageUrl =
    images["64x64@2"] ||
    (
      find(images, { width: 80, height: 80 }) as {
        url: string;
        width: number;
        height: number;
      }
    )?.url;

  return (
    <ImageWrapper>
      {imageUrl ? (
        <img className="w-16 h-16" src={imageUrl} alt={displayName} />
      ) : (
        <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center">
          <FontAwesomeIcon className="text-white" icon={faBullhorn} size="2x" />
        </div>
      )}
    </ImageWrapper>
  );
}
